// External libraries
import React, { useEffect } from 'react';
import { AddIcon } from '@paypalcorp/pp-react-icons-weasley-v7';

// Internal Modules
// @ts-expect-error TODO untyped import
import { InlineCRSTaxDetails } from './../CRSTaxDetails';
import {
  addNewTaxResidencyChangeHandler,
  // @ts-expect-error TODO untyped import
} from '../handlers';
// @ts-expect-error TODO untyped import
import { PlusLinkButton } from '../StyledComponents';
import { getContent, logger } from '@/lib';
import { ParentContainer } from '../../Common';
import { PP_SECONDARY_COLOR } from '@/styles';
import { useStoreState } from '@/store';

export const InlineCRSForm = (): React.ReactElement => {
  useEffect(() => {
    logger.fpti('crs_form_rendered', {
      state_name: 'crs_section',
      transition_name: 'process_crs_form_rendered',
    });
    logger.info('crs_form_rendered');
  }, []);
  const crsTaxDetails = useStoreState(({ form }) => form.crsTaxDetails);
  const crsTaxDetailsLength = crsTaxDetails?.value?.length ?? 0;
  return (
    <>
      <div data-testid="crs-tax-collection-section">
        {crsTaxDetails?.value?.map((_, index) => {
          return (
            <>
              <InlineCRSTaxDetails
                crsTaxDetails={crsTaxDetails.value}
                index={index}
                key={`crs-tax-details-${index}`}
              />
            </>
          );
        })}
      </div>
      {crsTaxDetailsLength < 5 && (
        <ParentContainer margin="30px 0 0 0">
          <PlusLinkButton
            type="button"
            data-testid="crs-add-tax-country"
            onClick={() =>
              addNewTaxResidencyChangeHandler({
                crsTaxDetails: crsTaxDetails?.value,
              })
            }
          >
            <AddIcon size="sm" color={PP_SECONDARY_COLOR} />
            {getContent('crs.addCountry')}
          </PlusLinkButton>
        </ParentContainer>
      )}
    </>
  );
};
